'use es6';

import Actions from 'AdsUI/lib/Actions';
import ReportRecord from 'AdsUI/records/reporting/ReportRecord';
const initialState = new ReportRecord({});
export default ((state = initialState, action) => {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case Actions.NETWORK_AGGREGATE_DATA_FETCH_START:
      return new ReportRecord({});

    case Actions.NETWORK_AGGREGATE_DATA_FETCH_SUCCEEDED:
      return payload ? new ReportRecord(Object.assign({}, payload.data.totals)) : state;

    default:
      return state;
  }
});